import React from "react";
import { EarningsCalendarHeaderProps } from "./types";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Home/EarningsCalendar/EarningsCalendarHeader";

const I18n = I18nUtil.createScoped(Translations);

/**
 * @description Earnings calendar header component
 */
export const EarningsCalendarHeader: React.FC<EarningsCalendarHeaderProps> = ({
  date,
  title = "Earnings Calendar",
}) => {
  return (
    <div className="flex-col items-start gap-2 w-full md:flex hidden">
      <div className="flex items-center justify-between w-full">
        <div className="text-content_primary font-medium text-base leading-6 whitespace-nowrap">
          {I18n.t(title)}
        </div>
        <div className="text-content_primary font-medium text-xs leading-4 whitespace-nowrap">
          {date}
        </div>
      </div>
    </div>
  );
};
